import { formatPriceWithCurrency } from '@vb-django/components/minskog/utils';

import { Text } from '@ui-component-library';

import { useCheckout } from '@components/Checkout/context/CheckoutContext';

export function MultiPlusDiscountSummary() {
  const { orderPrices } = useCheckout();

  const discount = orderPrices.MultiPlusDiscount as
    | { discountReason: string; discountAmount: number }
    | undefined;

  if (!discount) {
    return null;
  }

  return (
    <>
      <div className="flex flex-row items-start justify-start gap-2">
        <div className="flex flex-col gap-1">
          <Text variant="text-sm/leading-normal/medium">{discount.discountReason}</Text>
          <Text variant="text-sm/leading-normal/normal" className="text-pebble-500">
            - {formatPriceWithCurrency(discount.discountAmount)}
          </Text>
        </div>
      </div>
    </>
  );
}
